import moment from "moment";
import { ResidentLogs } from "@/enums/ResidentLogs";
import { mapState } from "vuex";
import * as firebase from "firebase";
import { serializer } from '@/api/shared/serializer';
import { EventsTypes } from "@/enums/EventsTypes";
import { reportPeriods } from "@/consts/reportPeriods";

export default {
  name: "Report360ViewEvents",
  props: {
    residentId: {
      type: String,
      default: null
    },
    period: {
      type: Number,
      default: 7
    },
    isPrintableMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      requestsByTypeItems: [],
      allCalenderEvents: [],
      lifestyleAttendanceEvents: [],
      conciergeAttendanceEvents: [],
      premiumAttendanceEvents: [],
      notAttendingEvents:[],
      ResidentLogs: ResidentLogs,
      Logs: {
        [ResidentLogs.PremiumEventsOpen]: {
          items: []
        },
        [ResidentLogs.CalendarEventsOpen]: {
          items: [],
          percent: 0
        },
        [ResidentLogs.LifestyleEventsOpen]: {
          items: [],
          percent: 0
        },
        [ResidentLogs.ConciergeEventsOpen]: {
          items: [],
          percent: 0
        },
        [ResidentLogs.EventsOpen]: {
          items: []
        },
        [ResidentLogs.EventsNotAttendingOpen]: {
          items: []
        },
        [ResidentLogs.EventsNotAttending]: {
          items: []
        },
      },
      selectedResidentId: null,
      periods: reportPeriods,
      headers: [],
    }
  },
  watch: {
    async period(value) {
      this.period = value

      await this.loadReportData(value)
    }
  },
  computed: {
    ...mapState({
      facility() {
        return this.$store.state.authModule.currentFacility;
      },
      resident() {
        return this.$store.state.residentModule.currentResident;
      },
      residentLogs() {
        return this.$store.state.residentModule.residentLogs;
      },
      LifestyleEvents(){ 
        return this.$store.state.calenderModule.calenderEvents.filter(x=>x.type=== EventsTypes.LifestylePrograms)
      }
    }),
    PremiumEventsAttendanceLogs() {
      return this.Logs[ResidentLogs.PremiumEventsOpen].items;
    },
    CalendarLogs() {
      return this.Logs[ResidentLogs.CalendarEventsOpen].items;
    },
    LifestyleLogs() {
      return this.Logs[ResidentLogs.LifestyleEventsOpen].items;
    },
    ConciergeLogs() {
      return this.Logs[ResidentLogs.ConciergeEventsOpen].items;
    },
    EventsOpenLogs() {
      return this.Logs[ResidentLogs.LifestyleEventsOpen].items.concat(this.Logs[ResidentLogs.ConciergeEventsOpen].items).concat(this.Logs[ResidentLogs.PremiumEventsOpen].items);
    },
    EventsNotAttendingOpenLogs() {
      return this.Logs[ResidentLogs.EventsNotAttendingOpen].items;
    },
    EventsNotAttendingLogs() {
      const arr = this.Logs[ResidentLogs.EventsNotAttending].items;
      if (arr.length) {
        let result = arr.reduce((total, current) => {
          const key = current.extraData.name;
          if (total[key]) {
            total[key].click++
          } else {
            total[key] = {
              click: 1,
              ...current
            }
          }
          return total;
        }, {});
        result = Object.values(result);
        return result;
      }
    }
  },
  methods: {
    async loadReportData(period){
      this.period = period
      await this.getResidentLogs(period, [
        ResidentLogs.EventsOpen,
        ResidentLogs.EventsNotAttendingOpen,
        ResidentLogs.EventsNotAttending,
        ResidentLogs.LifestyleEventsOpen,
        ResidentLogs.ConciergeEventsOpen,
        ResidentLogs.PremiumEventsOpen
      ]);
    },

    getWhereIdInIds(ids: string[], path: string, facilityId: string) {
      // don't run if there aren't any ids or a path for the collection
      if (!ids || !ids.length || !path) return [];
      const collectionPath = firebase.firestore().collection(path);
      const batches = [];
      while (ids.length) {
        // firestore limits batches to 10
        const batch = ids.splice(0, 10);
        // add the batch request to to a queue
        batches.push(
          collectionPath
            .where(firebase.firestore.FieldPath.documentId(), 'in', [...batch])
            .where('facilityId', '==', facilityId)
            .get()
            .then((results: any) => results.docs.map((result: any) => ({ id: result.id, ...result.data() })))
        )
      }
      // after all of the data is fetched, return it
      return Promise.all(batches).then((content: any) => content.flat());
    },

    filterEvents(period){
      const currentDate = moment();
      const startDate = moment(currentDate).subtract(period, 'days');
      const calenderEvents = [...this.allCalenderEvents].filter(event => { return moment(event.start) >= startDate && moment(event.start) <= currentDate});

      this.lifestyleAttendanceEvents = calenderEvents.filter(x=>x.type === EventsTypes.LifestylePrograms && x.attendeesIds?.length && x.attendeesIds.includes(this.selectedResidentId))
      this.conciergeAttendanceEvents = calenderEvents.filter(x=>x.type === EventsTypes.ConciergeRequest && x.attendeesIds?.length && x.attendeesIds.includes(this.selectedResidentId))
      this.premiumAttendanceEvents = calenderEvents.filter(x=>x.type === EventsTypes.PremiumServices && x.attendeesIds?.length && x.attendeesIds.includes(this.selectedResidentId))
      this.notAttendingEvents = calenderEvents.filter(x=> (x.type === EventsTypes.LifestylePrograms || x.type === EventsTypes.PremiumServices) 
        && x.residentsMembersIds?.includes(this.selectedResidentId) && !x.attendeesIds?.includes(this.selectedResidentId))

      const arr1: any = Object.values(this.groupByHour(this.lifestyleAttendanceEvents)).splice(-2);
      if (arr1.length === 2) {
        const num1 = arr1[0];
        const num2 = arr1[1];
        const result = (num2 - num1) / num1 * 100;
        this.lifestyleAttendanceEvents.percent = result.toFixed(0);
      }

      const arr2: any = Object.values(this.groupByHour(this.conciergeAttendanceEvents)).splice(-2);
      if (arr2.length === 2) {
        const num1 = arr2[0];
        const num2 = arr2[1];
        const result = (num2 - num1) / num1 * 100;
        this.conciergeAttendanceEvents.percent = result.toFixed(0);
      }

      const arr3: any = Object.values(this.groupByHour(this.premiumAttendanceEvents)).splice(-2);
      if (arr3.length === 2) {
        const num1 = arr3[0];
        const num2 = arr3[1];
        const result = (num2 - num1) / num1 * 100;
        this.premiumAttendanceEvents.percent = result.toFixed(0);
      }
    },

    async getResidentLogs(period, eventTypes) {

      this.filterEvents(period)

      const fromDate = moment().subtract(period, "days").toDate();
      await firebase
        .firestore()
        .collection("residents")
        .doc(this.selectedResidentId)
        .collection("events")
        .where("facilityId", "==", this.facility)
        .where("eventDateTime", ">=", fromDate)
        .where("eventType", "in", eventTypes)
        .get()
        .then(async querySnapshot => {
          const logs = querySnapshot.docs.map(log => {
            const data = log.data();
            const start = moment(data.eventDateTime.seconds * 1000).toDate();
            const extraData = JSON.parse(data.extraData.replace(/'/g, '"'));
            data.start = start;
            data.extraData = extraData;
            return {
              ...data
            };
          });

          const logsResult = logs.reduce((total, current) => {
            const key = current.eventType;
            if (total[key]) {
              total[key].push(current);
            } else {
              total[key] = [current];
            }
            return total;
          }, {});

          Object.keys(logsResult).forEach(key => {
            this.Logs[key].items = logsResult[key];
            if (key != ResidentLogs.PremiumEventsOpen) {
              const arr: any = Object.values(this.groupByHour(this.Logs[key].items)).splice(-2);
              if (arr.length === 2) {
                const num1 = arr[0];
                const num2 = arr[1];
                const result = (num2 - num1) / num1 * 100;
                this.Logs[key].percent = result.toFixed(0);
              }
            }
          });

          eventTypes.forEach(type => {
            if (!Object.keys(logsResult).includes(type)) {
              this.Logs[type].items = [];
              this.Logs[type].percent = 0;
            }
          });

          this.requestsByTypeItems = await this.getRequestsByType(fromDate);
        });
    },

    async getRequestsByType(fromDate) {

      const items = this.Logs[ResidentLogs.PremiumEventsOpen].items

      if (!items.length) return []

      const eventIds = items.map(item => item.extraData.eventId).filter((value, index, self) => value && self.indexOf(value) === index)

      const events = await firebase
        .firestore()
        .collection('calender')
        .where('facilityId', '==', this.facility)
        .where("start", ">=", fromDate).get()

      const arrays = events.docs.filter(x => eventIds.includes(x.id)).map((e: any) => (e.data().attendeesIds))

      //merge arrays and remove duplicates
      const residentIds = arrays.flat(1).filter((value, index, self) => value && self.indexOf(value) === index)

      if (residentIds.length) {

        const query = await firebase
          .firestore()
          .collection('serviceRequests')
          .where('facilityId', '==', this.facility)
          .where('residentId', 'in', residentIds)
          .get()

        const serviceRequests = serializer.querySnapshotToDocuments(query) as any[]

        const arraysEvents = events.docs.filter(x => eventIds.includes(x.id)).map((x) => {
          const n = x.data();
          n.id = x.id;
          n.start = moment(n.start.seconds * 1000).toDate();
          return n;
        })

        arraysEvents.forEach(event => {
          const sr = serviceRequests.find(x => event.invitees.includes(x.serviceId))
          if (sr) {
            event.serviceType = sr.serviceType
          }
          else {
            event.serviceType = 'Undefined type'
          }
        })

        const result = arraysEvents.reduce((result, current: any) => {

          const serviceType = current["serviceType"];
          const date = moment(current.start).startOf("day").format("YYYY-MM-DD");
          const findedDate = result.find(request => request.name === serviceType);

          if (findedDate) {
            findedDate.data[date] = findedDate.data[date] ? findedDate.data[date] + 1 : 1;
          } else {
            result.push({ name: serviceType, data: { [date]: 1 } });
          }

          return result;
        }, []);


        const arr = Object.values(this.groupByHour(arraysEvents)).splice(-2) as any;
        if (arr.length === 2) {
          const num1 = arr[0];
          const num2 = arr[1];
          const result = (num2 - num1) / num1 * 100;
          this.Logs[ResidentLogs.PremiumEventsOpen].percent = result.toFixed(0);
        }

        return result
      }

      return []
    },

    async getResidentPremiumServices() {

      const idsEvents = [];
      const arr = this.PremiumEventsAttendanceLogs.reduce((total, current) => {
        const key = current.extraData.eventId;
        if (!total.find(el => el.eventId === key)) {
          total.push({ eventId: key });
          idsEvents.push(key);
        }
        return total;
      }, []);


      if (idsEvents.length) {
        const idsServices = await this.getWhereIdInIds(idsEvents, 'calender', this.facility)
          .then(records => {
            const resList: Array<any> = [];
            records.forEach(log => {
              const data = log;
              data.id = log.id;
              resList.push(data.invitees[0]);

              arr.forEach((item, index) => {
                if (arr.find(el => el.eventId === data.id)) {
                  arr[index].serviceId = data.invitees[0];
                }
              });
            });
            return resList;
          });


        const records = await this.getWhereIdInIds(idsServices, 'additionalServices', this.facility)

        records.forEach(log => {
          const data = log;
          const residents = data.membersList;
          let serviceType = "";

          residents.forEach(member => {
            if (member.id === this.selectedResidentId) {
              if (Object.prototype.hasOwnProperty.call(member, 'isOneOff') && member.isOneOff) {
                member.serviceType = "One-Off Charge";
              } else {
                member.serviceType = "Daily Charge";
              }
              serviceType = member.serviceType;
            }
          });
          arr.forEach((item, index) => {
            if (arr.find(el => el.serviceId === data.id)) {
              arr[index].serviceType = serviceType;
            }
          });
        });
      }

      this.PremiumEventsAttendanceLogs = this.PremiumEventsAttendanceLogs.map(log => {
        arr.forEach(item => {
          if (log.extraData.eventId === item.eventId) {
            log.extraData.serviceType = item.serviceType;
          }
        });
      });

    },

    groupByHour(visits) {
      const types = visits.reduce(function (totals, visit) {
        const dayOfWeek = moment(visit.start).startOf("day").format("LL");
        !totals[dayOfWeek]
          ? (totals[dayOfWeek] = 1)
          : (totals[dayOfWeek] = totals[dayOfWeek] + 1);
        return totals;
      }, {});

      return types;
    },

    getDailyCount(events) {
      const types = events.reduce(function (totals, event) {
        const date = moment(event.start)
          .startOf("day")
          .format("D/MM");
        !totals[date] ? (totals[date] = 1) : (totals[date] = totals[date] + 1);
        return totals;
      }, {});
      return types;
    },

    backToReport360() {
      this.$router.push(`/reports/reports360/${this.selectedResidentId}`);
    },

    goToEvent(event) {
      this.$router.push("/calendar/" + event.id);
    }
  },
  async created() {

    await this.$store.dispatch('getAdditionalServices');

    this.selectedResidentId = this.residentId || this.$route.params.id
    this.allCalenderEvents = (await this.$store.dispatch('getCalenderEvents', { start: moment().subtract(1, "month").startOf("day").toDate(), end: moment().toDate() }))
    .map(x => { x.start = moment(x.start.seconds * 1000).toDate(); return x; });

    this.headers = [
      {
        text: this.$t('ViewCalendarItem.EventType'),
        value: "name"
      },
      {
        text: this.$t('GeneralTranslations.Name'),
        value: "type"
      }
    ]

    this.$store.dispatch("getFacility");

    this.$store.dispatch("getResident", this.selectedResidentId);

    await this.loadReportData(this.period)

    await this.getResidentPremiumServices();

    this.$emit('report360ViewEventsDataLoaded')
  }
};
